import(/* webpackMode: "eager" */ "/home/chronicleusa/public_html/chronicles-exhibits/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/chronicleusa/public_html/chronicles-exhibits/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/header.jsx");
